function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#363139",
  strokeWidth: 1.3,
  cx: 8.45,
  cy: 8.45,
  r: 8.45
}), /*#__PURE__*/React.createElement("path", {
  fill: "#363139",
  fillRule: "nonzero",
  d: "M14.314 15.206l.892-.892 7.354 7.353-.893.893z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#363139",
  x: 8,
  y: 3,
  width: 1,
  height: 11,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#363139",
  transform: "rotate(-90 8.5 8.5)",
  x: 8,
  y: 3,
  width: 1,
  height: 11,
  rx: 0.5
}));

function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+NTEzM0JDOTEtMDlFNC00QTJFLUJBODctQjRGMzA1OUUyQzI0PC90aXRsZT4KICAgIDxnIGlkPSIwMS4tUERQIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iRF8wMV9QRFBfMDNfT3Blbi1TdGF0ZXNfUmVhbC1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjg5LjAwMDAwMCwgLTI5Mi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IkltYWdlcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODcuMDAwMDAwLCAyNjEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iSWNvbi9ab29tIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MDIuMDAwMDAwLCAzMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iWm9vbSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIHN0cm9rZT0iIzM2MzEzOSIgc3Ryb2tlLXdpZHRoPSIxLjMiIGZpbGwtcnVsZT0ibm9uemVybyIgY3g9IjguNDUiIGN5PSI4LjQ1IiByPSI4LjQ1Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzM2MzEzOSIgZmlsbC1ydWxlPSJub256ZXJvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOC40MzY1NzUsIDE4LjQzNjU3NSkgcm90YXRlKC00NS4wMDAwMDApIHRyYW5zbGF0ZSgtMTguNDM2NTc1LCAtMTguNDM2NTc1KSAiIHBvaW50cz0iMTcuODA1NjkyMyAxMy4yMzY1NzQ3IDE5LjA2NzQ1NyAxMy4yMzY1NzQ3IDE5LjA2NzQ1NyAyMy42MzY1NzQ3IDE3LjgwNTY5MjMgMjMuNjM2NTc0NyI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjMzYzMTM5IiB4PSI4IiB5PSIzIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMSIgcng9IjAuNSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHkiIGZpbGw9IiMzNjMxMzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguNTAwMDAwLCA4LjUwMDAwMCkgcm90YXRlKC05MC4wMDAwMDApIHRyYW5zbGF0ZSgtOC41MDAwMDAsIC04LjUwMDAwMCkgIiB4PSI4IiB5PSIzIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMSIgcng9IjAuNSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgZoomIn as ReactComponent };